import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DevsTable from "../../components/Devs/DevsTable";




const DevsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Devs" />

       {/* Devs Table */}
        <DevsTable />   

      </MasterLayout>
    </>
  );
};

export default DevsPage;
